__turbopack_context__.v({
  "accordion-reference": "Si85zG_accordion-reference",
  "ant-collapse": "Si85zG_ant-collapse",
  "ant-image": "Si85zG_ant-image",
  "article-contents": "Si85zG_article-contents",
  "article-image": "Si85zG_article-image",
  "btn": "Si85zG_btn",
  "btnFooter": "Si85zG_btnFooter",
  "cards": "Si85zG_cards",
  "category": "Si85zG_category",
  "category-mobile": "Si85zG_category-mobile",
  "col-btn-share": "Si85zG_col-btn-share",
  "content": "Si85zG_content",
  "copy-btn": "Si85zG_copy-btn",
  "divider": "Si85zG_divider",
  "headContact": "Si85zG_headContact",
  "hideScrollbar": "Si85zG_hideScrollbar",
  "icons": "Si85zG_icons",
  "img-wrapp-share": "Si85zG_img-wrapp-share",
  "list": "Si85zG_list",
  "list-category": "Si85zG_list-category",
  "list-desc": "Si85zG_list-desc",
  "list-divider": "Si85zG_list-divider",
  "list-img": "Si85zG_list-img",
  "list-reviewer": "Si85zG_list-reviewer",
  "list-title": "Si85zG_list-title",
  "p": "Si85zG_p",
  "page-body-wrap": "Si85zG_page-body-wrap",
  "page-break-section": "Si85zG_page-break-section",
  "pagehero": "Si85zG_pagehero",
  "paragraph-content": "Si85zG_paragraph-content",
  "paragraph1": "Si85zG_paragraph1",
  "paragraph2": "Si85zG_paragraph2",
  "paragraph3": "Si85zG_paragraph3",
  "phonecontent": "Si85zG_phonecontent",
  "related": "Si85zG_related",
  "row-detail-share": "Si85zG_row-detail-share",
  "section": "Si85zG_section",
  "sectionright": "Si85zG_sectionright",
  "share-btn": "Si85zG_share-btn",
  "sosmed": "Si85zG_sosmed",
  "store": "Si85zG_store",
  "t": "Si85zG_t",
  "title": "Si85zG_title",
  "title1": "Si85zG_title1",
  "wrap-article-detail": "Si85zG_wrap-article-detail",
  "wrap-container": "Si85zG_wrap-container",
  "wrap-content": "Si85zG_wrap-content",
});
